import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      margin: theme.spacing(1, 0),
    },
    label: {
      fontSize: '10px',
      fontWeight: 400,
      color: '#272727',
      letterSpacing: '0.5px',
      lineHeight: '16px',
      whiteSpace: 'nowrap',
    },
    buttonContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    radioGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexDirection: 'row',
    },
    radio: {
      display: 'none',
    },
    radioLabel: {
      fontSize: '10px',
      fontWeight: 400,
      color: '#272727',
      letterSpacing: '0.5px',
      lineHeight: '16px',
      padding: '2px 4px',
      margin: 0,
      cursor: 'pointer',
      borderRadius: '5px',
      backgroundColor: 'transparent',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '10px',
        fontWeight: 400,
        color: '#272727',
        letterSpacing: '0.5px',
        lineHeight: '16px',
        padding: 0,
        margin: 0,
        textDecoration: 'none',
      },
    },
    buttonActive: {
      backgroundColor: '#f0f1eb',
      textDecoration: 'underline',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      '& .MuiFormControlLabel-label': {
        textDecoration: 'underline',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
      },
    },
    divider: {
      height: '16px',
      width: '0.1rem',
      backgroundColor: theme.palette.secondary.main,
    },
  }),
)
